/*
 * <plp-layout-switch> – switches the collection grid between tiles (class "list") and rows
 * (class "grid") and remembers the choice in localStorage. Buttons carry data-layout.
 */
if (!customElements.get("plp-layout-switch")) {
  customElements.define(
    "plp-layout-switch",
    class PlpLayoutSwitch extends HTMLElement {
      static STORAGE_KEY = "plpLayout";
      static DEFAULT_LAYOUT = "list";

      connectedCallback() {
        this.buttons = [...this.querySelectorAll("[data-layout]")];
        this.collectionContainer = document.querySelector("#ProductGridContainer .collection");
        if (!this.collectionContainer) return;

        this.applyLayout(this.storedLayout());

        this.abortController = new AbortController();
        this.addEventListener(
          "click",
          (event) => {
            const button = event.target.closest("[data-layout]");
            if (!button) return;
            this.store(button.dataset.layout);
            this.applyLayout(button.dataset.layout);
          },
          { signal: this.abortController.signal }
        );
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      storedLayout() {
        try {
          const layout = localStorage.getItem(PlpLayoutSwitch.STORAGE_KEY);
          return layout === "grid" || layout === "list" ? layout : PlpLayoutSwitch.DEFAULT_LAYOUT;
        } catch (error) {
          return PlpLayoutSwitch.DEFAULT_LAYOUT;
        }
      }

      store(layout) {
        try {
          localStorage.setItem(PlpLayoutSwitch.STORAGE_KEY, layout);
        } catch (error) {
          // storage blocked: the layout just isn't remembered
        }
      }

      applyLayout(layout) {
        this.collectionContainer.classList.remove("list", "grid");
        this.collectionContainer.classList.add(layout);
        this.buttons.forEach((button) => {
          const isActive = button.dataset.layout === layout;
          button.classList.toggle("active", isActive);
          button.setAttribute("aria-pressed", String(isActive));
        });
      }
    }
  );
}
